<template>
  <div id="app">
    <transition name='fade' mode='out-in'>
      <router-view/>
    </transition>
  </div>
</template>

<script>
export default {
  name: "app",
  mounted() {}
};
</script>

<style>
* {
  margin: 0;
  padding: 0;
}

#app {
  width: 100%;
  height: auto;
  background: #fff;
}

.fade-enter-active,
.fade-leave-active {
  transition: all 0.2s ease;
}

.fade-enter,
.fade-leave-active {
  opacity: 0;
}
@media (max-width: 1680px) {
  .have-zoom {
    zoom: 0.9;
  }
}
@media (max-width: 1400px) {
  .have-zoom {
    zoom: 0.8;
  }
}

</style>



// WEBPACK FOOTER //
// src/App.vue